"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  row: {
    display: 'flex',
    '&.xxsmall': {
      gap: `${theme.spaceSize.xxsmall}px`
    },
    '&.xsmall': {
      gap: `${theme.spaceSize.xsmall}px`
    },
    '&.small': {
      gap: `${theme.spaceSize.small}px`
    }
  },
  switchWrap: {
    borderColor: theme.toggleSwitch.borderColor,
    borderStyle: 'solid',
    position: 'relative',
    transition: theme.transition(['all']),
    cursor: 'pointer',
    '&.active': {
      borderColor: theme.toggleSwitch.borderActiveColor
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: theme.disabledCursor
    },
    '&.hidden': {
      display: 'none'
    },
    '&.error': {
      borderColor: theme.errorColor
    }
  },
  switch: {
    position: 'absolute',
    top: 2,
    margin: '0 2px',
    backgroundColor: theme.toggleSwitch.color,
    borderRadius: 12,
    transition: theme.transition(['all']),
    '&.active': {
      backgroundColor: theme.toggleSwitch.activeColor,
      right: 0
    },
    '&.error': {
      backgroundColor: theme.errorColor
    }
  },
  helperText: {
    color: theme.checkbox.textColor,
    marginTop: 4
  },
  small: {
    width: theme.toggleSwitch.small.width,
    height: theme.toggleSwitch.small.height,
    borderRadius: theme.toggleSwitch.small.height,
    borderWidth: theme.toggleSwitch.small.border,
    '& $switch': {
      width: theme.toggleSwitch.small.height - 4,
      height: theme.toggleSwitch.small.height - 4
    }
  },
  medium: {
    width: theme.toggleSwitch.medium.width,
    height: theme.toggleSwitch.medium.height,
    borderRadius: theme.toggleSwitch.medium.height,
    borderWidth: theme.toggleSwitch.medium.border,
    '& $switch': {
      width: theme.toggleSwitch.medium.height - 4,
      height: theme.toggleSwitch.medium.height - 4
    }
  },
  large: {
    width: theme.toggleSwitch.large.width,
    height: theme.toggleSwitch.large.height,
    borderRadius: theme.toggleSwitch.large.height,
    borderWidth: theme.toggleSwitch.large.border,
    '& $switch': {
      width: theme.toggleSwitch.large.height - 4,
      height: theme.toggleSwitch.large.height - 4
    }
  }
});

exports.default = _default;